import _ from 'lodash';
import { MenuItem } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import { Trans } from '@lingui/macro';
import NgpToggle from '../../form/NgpToggle';
import {
    ALERT_CRITICAL,
    ALERT_LEVEL_OPTIONS,
    NOTIFICATIONS_ALERTLEVEL_FIELD,
    NOTIFICATIONS_ENABLED_FIELD,
    POLICIES,
} from './NotificationPolicyConstants';
import NgpSelect from '../../form/NgpSelect';
import { useSettingStyles } from './NotificationPolicySettingsStyles';
import EmailNotifications from './EmailNotifications';
import FormSection from '../../form/FormSection';
import SnmpNotifications from './SnmpNotifications';

export default function NotificationPolicySetting(props) {
    const { activeTab, data, setNotifySelectionIsDirty, setSnmpTrapSelectionIsDirty } = props;
    const classes = useSettingStyles();
    const { watch } = useFormContext();
    const policyEnabled = watch(NOTIFICATIONS_ENABLED_FIELD);

    const getAlertLevels = () => {
        return POLICIES[activeTab].hasCritical
            ? ALERT_LEVEL_OPTIONS
            : _.filter(ALERT_LEVEL_OPTIONS, (i) => i.value !== ALERT_CRITICAL);
    };

    return (
        <>
            <NgpToggle fieldName={NOTIFICATIONS_ENABLED_FIELD} label={POLICIES[activeTab].toggleLabel} />
            {policyEnabled && (
                <>
                    <FormSection addSpacer>
                        <NgpSelect
                            className={classes.severitySelection}
                            fieldName={NOTIFICATIONS_ALERTLEVEL_FIELD}
                            label={<Trans>Severity over or equal</Trans>}
                            required
                        >
                            {_.map(getAlertLevels(), (value, key) => (
                                <MenuItem key={key} value={value.value}>
                                    {value.display}
                                </MenuItem>
                            ))}
                        </NgpSelect>
                    </FormSection>
                    <EmailNotifications
                        notification={data}
                        setNotifySelectionIsDirty={setNotifySelectionIsDirty}
                        selectedType={POLICIES[activeTab]}
                    />
                    <SnmpNotifications
                        notification={data}
                        setSnmpTrapSelectionIsDirty={setSnmpTrapSelectionIsDirty}
                        selectedType={POLICIES[activeTab]}
                    />
                </>
            )}
        </>
    );
}
